<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            {{ symTax.description }}
        </template>

        <template v-slot:header>
            <div>
                <span class="text-semibold">Tax ID: </span>{{ symTax.unique_tax_id }}
            </div>
        </template>

        <slot>
            <div class="card mb-2">
                <div class="card-header pr-1 d-flex align-items-center">
                    <span class="btnlike mr-auto">
                        <h4 class="mb-0">Details</h4>
                    </span>
                </div>

                <div class="card-body py-1">
                    <section class="item-details-section">
                        <div>
                            <span class="text-semibold">Tax Type: </span>
                            <span>{{ symTax.tax_type }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">State</span>
                            <span>{{ symTax.state_name }} ({{ symTax.state_abbreviation }})</span>
                        </div>

                        <div>
                            <span class="text-semibold">State Code: </span>
                            <span>{{ symTax.state_code }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">City: </span>
                            <span>{{ symTax.city_name }} <span v-if="symTax.city_code">({{ symTax.city_code }})</span></span>
                        </div>

                        <div>
                            <span class="text-semibold">County: </span>
                            <span>{{ symTax.county_name }} <span v-if="symTax.county_code">({{ symTax.county_code }})</span></span>
                        </div>

                        <div>
                            <span class="text-semibold">Employer Tax: </span>
                            <span>{{ symTax.is_employer_tax ? 'Yes' : 'No' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Rate: </span>
                            <span>{{ symTax.rate ? symTax.rate : '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Wage Base: </span>
                            <span>{{ symTax.wage_base != null ? symTax.wage_base : '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Tax Limit Period: </span>
                            <span>{{ symTax.tax_limit_period || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Tax ID Suffix: </span>
                            <span>{{ symTax.tax_id_suffix || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Effective Date: </span>
                            <span>{{ symTax.tax_effective_date || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Installation Date: </span>
                            <span>{{ symTax.tax_installation_date || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Is Active: </span>
                            <span>{{ symTax.is_active ? 'Yes' : 'No' }}</span>
                        </div>
                    </section>
                </div>
            </div>

            <div class="card mb-2">
                <div class="card-header pr-1 d-flex align-items-center">
                    <span class="btnlike mr-auto">
                        <h4 class="mb-0">Asure Codes</h4>
                    </span>
                    <button class="btn btn-outline-primary" type="button" @click.prevent.stop="asureModalOpen = true">
                        <i class="far fa-pencil" aria-hidden="true" title="Edit"></i>&nbsp;Edit
                    </button>
                </div>

                <div class="card-body py-1">
                    <section class="item-details-section">
                        <div>
                            <span class="text-semibold">Asure Code: </span>
                            <span>{{ symTax.asure_code || '—' }}</span>
                        </div>

                        <div>
                            <span class="text-semibold">Asure Code (Non-Resident): </span>
                            <span>{{ symTax.asure_code_non_resident || '—' }}</span>
                        </div>
                    </section>
                </div>
            </div>

            <sym-tax-modal
                v-if="asureModalOpen"
                :sym-tax="symTax"
                @updated="$emit('updated', $event)"
                @close="asureModalOpen = false"
            />
        </slot>
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import SymTaxModal from './SymTaxModal'

export default {
    components: {Sidebar, SymTaxModal, },
    props: ['symTax'],
    data() {
        return {
            asureModalOpen: false,
        }
    },
}
</script>
